// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__11oom","rootSmall":"AddTileButton_rootSmall__2DiJE"};